import * as apiCoreIam from "../services/core-iam";
import { normalizeTheme, THEME_LIGHT } from "../theme/theme.utils";

const DEFAULT_USER_SETTINGS = {
  temperatureUnit: "Celsius",
  pressureUnit: "bar",
  language: "English_en-GB",
  theme: THEME_LIGHT,
};

const isBlank = (value) => value === null || value === undefined || value === "";

const mapTemperatureUnit = (unit) => {
  if (isBlank(unit)) {
    return DEFAULT_USER_SETTINGS.temperatureUnit;
  }

  switch (unit.toString().trim().toLowerCase()) {
    case "°c":
    case "celsius":
      return "Celsius";
    case "°f":
    case "fahrenheit":
      return "Fahrenheit";
    default:
      return unit;
  }
};

const mapPressureUnit = (unit) => {
  if (isBlank(unit)) {
    return DEFAULT_USER_SETTINGS.pressureUnit;
  }

  switch (unit.toString().trim().toLowerCase()) {
    case "bar":
      return "bar";
    case "psi":
      return "PSI";
    // Canonicalise to "kPa" (the spelling the rest of the app switches on).
    // Accept the "kPa" symbol and, defensively, the "KiloPascal" enum name.
    case "kpa":
    case "kilopascal":
      return "kPa";
    default:
      return unit;
  }
};

const mapLanguage = (lang) => {
  if (isBlank(lang)) {
    return DEFAULT_USER_SETTINGS.language;
  }

  switch (lang.toString().trim().toLowerCase()) {
    case "en":
    case "en-gb":
    case "english_en-gb":
      return "English_en-GB";
    case "it":
    case "it-it":
    case "italiano_it-it":
      return "Italiano_it-IT";
    default:
      return lang;
  }
};

export const mapTheme = (theme) => normalizeTheme(theme);

export const getUserAttribute = async () => {
  try {
    const response = await apiCoreIam.getSelfAsync();
    const settings = response?.settings ?? {};

    return {
      temp_unit: mapTemperatureUnit(settings.temperatureUnit),
      press_unit: mapPressureUnit(settings.pressureUnit),
      language: mapLanguage(settings.language),
      theme: mapTheme(settings.theme),
    };
  } catch (error) {
    return null;
  }
};
